import { ReactElement, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

import BravoContent from './BravoContent';
import BravoFooter from './BravoFooter';
import BravoHeader from './BravoHeader';
import BravoLayout from './BravoLayout';
import { Spinner } from '../spinner';
import BravoAdminHeader from './BravoAdminHeader/BravoAdminHeader';
import ViewAsUserHeader from 'pages/admin/components/ViewAsUserHeader';
import { useCheckAdminLoggedIn } from 'hooks/useCheckAdminLoggedIn';
export interface LayoutProps {
  placeholder: ReactElement;
}
import loginBackImg from '../../assets/images/login-background.png';
import './index.less';
const Layout = ({ placeholder }: LayoutProps) => {
  const location = useLocation();
  const isAdminLoggedIn = useCheckAdminLoggedIn();
  const showAdminHeader = location?.pathname.startsWith('/admin');
  const showViewAsUser = isAdminLoggedIn && !showAdminHeader;
  const { t } = useTranslation();

  return (
    <BravoLayout
      style={
        location?.pathname.includes('login') ||
        location?.pathname.includes('register') ||
        location?.pathname.includes('forgot')
          ? {
              zIndex: 0,
              background: `url(${loginBackImg}) no-repeat center center/cover`,
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // 通过黑色的半透明背景使背景图片变暗
            }
          : {}
      }
    >
      <div>
        <Helmet>
          <title>{t('common.metaTag.title')}</title>
          <meta name="description" content={t('common.metaTag.description')}></meta>
          <meta name="keywords" content={t('common.metaTag.keywords')}></meta>
        </Helmet>
        {isAdminLoggedIn && !showAdminHeader && <ViewAsUserHeader />}
        {showAdminHeader ? <BravoAdminHeader /> : <BravoHeader showViewAsUser={showViewAsUser} />}
        {placeholder}
      </div>

      {/* 全屏遮罩层 */}
      {(location?.pathname.includes('login') ||
        location?.pathname.includes('register') ||
        location?.pathname.includes('forgot')) && (
        <div
          className={location?.pathname.includes('register') ? 'register_fix' : ''}
          style={{
            position: 'fixed', // 固定在页面顶部
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(32, 37, 43, 0.6)', // 黑色透明遮罩层
            zIndex: 0, // 确保遮罩层在底部
          }}
        />
      )}

      <BravoContent>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </BravoContent>
      {!location?.pathname.includes('genbravo/payment/return') && <BravoFooter />}
    </BravoLayout>
  );
};

export default Layout;
